// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const CreditCardGradient = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M47.82 42.174H9.182c-.766 0-1.39-.623-1.39-1.39V25.492H49.21v15.292c0 .767-.624 1.39-1.39 1.39ZM9.182 13.825H47.82c.766 0 1.39.623 1.39 1.39v3.277H7.792v-3.277c0-.767.624-1.39 1.39-1.39Zm38.638-2.333H9.182a3.727 3.727 0 0 0-3.723 3.723v25.57a3.727 3.727 0 0 0 3.723 3.722H47.82a3.727 3.727 0 0 0 3.723-3.723V15.215a3.727 3.727 0 0 0-3.723-3.723Z"
			fill="url(#CreditCardGradient_tsx__a)"
		/>
		<defs>
			<linearGradient
				id="CreditCardGradient_tsx__a"
				x1={5.459}
				y1={11.492}
				x2={5.459}
				y2={44.507}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#60B4E7" />
				<stop offset={1} stopColor="#6461E0" />
			</linearGradient>
		</defs>
	</svg>
);
export default CreditCardGradient;
